export const environment = {
  production: false,
  baseURL: "/api"
};


